/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Type = 1 | 2;

export const Type = {
    NUMBER_1: 1 as Type,
    NUMBER_2: 2 as Type
};

